import CiiRatingsData from "./data";

export default function mapCiiRatingsDataFromJson(json) {
    return new CiiRatingsData(
        json['required_cii'],
        json['a_rating'],
        json['b_rating'],
        json['c_rating'],
        json['d_rating']
    );
}




